'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const map = require('lodash/map');
const url = require('url');
const querystring = require('querystring');

import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    className: PropTypes.string,
    template: PropTypes.object.isRequired,
    create_info: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const defaultProps = {
    className: "",
};

class TemplateCreateInfoEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.setText = this.setText.bind(this);
        this.onChangeHowToPlayStep = this.onChangeHowToPlayStep.bind(this);
        this.onChangeHowToPlayText = this.onChangeHowToPlayText.bind(this);
        this.onInsertHowToPlayStep = this.onInsertHowToPlayStep.bind(this);
        this.onMoveHowToPlayStep = this.onMoveHowToPlayStep.bind(this);
        this.onDeleteHowToPlayStep = this.onDeleteHowToPlayStep.bind(this);
        this.onChangeObjectiveText = this.onChangeObjectiveText.bind(this);
        this.onInsertObjectiveStep = this.onInsertObjectiveStep.bind(this);
        this.onMoveObjectiveStep = this.onMoveObjectiveStep.bind(this);
        this.onDeleteObjectiveStep = this.onDeleteObjectiveStep.bind(this);
        this.onChangeAuthoringStepsText = this.onChangeAuthoringStepsText.bind(this);
        this.onInsertAuthoringStep = this.onInsertAuthoringStep.bind(this);
        this.onMoveAuthoringStep = this.onMoveAuthoringStep.bind(this);
        this.onDeleteAuthoringStep = this.onDeleteAuthoringStep.bind(this);
        this.onChangeAssetTypesText = this.onChangeAssetTypesText.bind(this);
        this.onInsertAssetType = this.onInsertAssetType.bind(this);
        this.onMoveAssetType = this.onMoveAssetType.bind(this);
        this.onDeleteAssetType = this.onDeleteAssetType.bind(this);
        this.extractYouTubeVideoID = this.extractYouTubeVideoID.bind(this);
        this.setVideoID = this.setVideoID.bind(this);
        this.renderAuthoringStepsImageChooser = this.renderAuthoringStepsImageChooser.bind(this);
        this.renderAssetTypesImageChooser = this.renderAssetTypesImageChooser.bind(this);
    }
    
    setText(k,evt) {
        var ci = JSON.parse(this.props.create_info);
        ci[k] = evt.target.value;
        this.props.onChange(JSON.stringify(ci));
    }
    
    onChangeHowToPlayStep(index,evt) {
        var ci = JSON.parse(this.props.create_info);
        ci.howToPlaySteps[index].step = Number(evt.target.value);
        this.props.onChange(JSON.stringify(ci));
    }
    
    onChangeHowToPlayText(index,evt) {
        var ci = JSON.parse(this.props.create_info);
        ci.howToPlaySteps[index].text = evt.target.value;
        this.props.onChange(JSON.stringify(ci));
    }

    onInsertHowToPlayStep(index) {
        var ci = JSON.parse(this.props.create_info);
        ci.howToPlaySteps.splice(index,0,{
            step: index+1,
            text: ''
        });
        for (var i=index; i<ci.howToPlaySteps.length; ++i) {
            if (ci.howToPlaySteps[i].step === i) {
                ci.howToPlaySteps[i].step = i+1;
            }
        }
        
        this.props.onChange(JSON.stringify(ci));
    }

    onMoveHowToPlayStep(index,delta) {
        if (!delta) {
            return;
        }
        var ci = JSON.parse(this.props.create_info);
        var a1 = ci.howToPlaySteps[index];
        var a2 = ci.howToPlaySteps[index+delta];
        if (a1 && a2) {
            ci.howToPlaySteps[index] = a2;
            ci.howToPlaySteps[index+delta] = a1;
            this.props.onChange(JSON.stringify(ci));
        }
    }

    onDeleteHowToPlayStep(index) {
        var ci = JSON.parse(this.props.create_info);
        ci.howToPlaySteps.splice(index,1);
        
        for (var i=index; i<ci.howToPlaySteps.length; ++i) {
            if (ci.howToPlaySteps[i].step === i+2) {
                ci.howToPlaySteps[i].step = i+1;
            }
        }
        
        this.props.onChange(JSON.stringify(ci));
    }
    
    onChangeObjectiveText(index,key,evt) {
        var ci = JSON.parse(this.props.create_info);
        ci.objectives[index][key] = evt.target.value;
        this.props.onChange(JSON.stringify(ci));
    }

    onInsertObjectiveStep(index) {
        var ci = JSON.parse(this.props.create_info);
        ci.objectives.splice(index,0,{
            title: 'title ' + index,
            subtitle: 'subtitle ' + index
        });
        this.props.onChange(JSON.stringify(ci));
    }

    onMoveObjectiveStep(index,delta) {
        if (!delta) {
            return;
        }
        var ci = JSON.parse(this.props.create_info);
        var a1 = ci.objectives[index];
        var a2 = ci.objectives[index+delta];
        if (a1 && a2) {
            ci.objectives[index] = a2;
            ci.objectives[index+delta] = a1;
            this.props.onChange(JSON.stringify(ci));
        }
    }

    onDeleteObjectiveStep(index) {
        var ci = JSON.parse(this.props.create_info);
        ci.objectives.splice(index,1);
        this.props.onChange(JSON.stringify(ci));
    }
    
    onChangeAuthoringStepsText(index,key,evt) {
        var ci = JSON.parse(this.props.create_info);
        ci.authoringSteps[index][key] = evt.target.value;
        this.props.onChange(JSON.stringify(ci));
    }

    onInsertAuthoringStep(index) {
        var ci = JSON.parse(this.props.create_info);
        ci.authoringSteps.splice(index,0,{
            text: '',
            image: 'Introduction.png'
        });
        this.props.onChange(JSON.stringify(ci));
    }

    onMoveAuthoringStep(index,delta) {
        if (!delta) {
            return;
        }
        var ci = JSON.parse(this.props.create_info);
        var a1 = ci.authoringSteps[index];
        var a2 = ci.authoringSteps[index+delta];
        if (a1 && a2) {
            ci.authoringSteps[index] = a2;
            ci.authoringSteps[index+delta] = a1;
            this.props.onChange(JSON.stringify(ci));
        }
    }

    onDeleteAuthoringStep(index) {
        var ci = JSON.parse(this.props.create_info);
        ci.authoringSteps.splice(index,1);
        this.props.onChange(JSON.stringify(ci));
    }
    
    onChangeAssetTypesText(index,key,evt) {
        var ci = JSON.parse(this.props.create_info);
        ci.assetTypes[index][key] = evt.target.value;
        this.props.onChange(JSON.stringify(ci));
    }
    
    onInsertAssetType(index) {
        var ci = JSON.parse(this.props.create_info);
        ci.assetTypes.splice(index,0,{
            title: 'Text ' + (index+1),
            image: 'Text.png'
        });
        this.props.onChange(JSON.stringify(ci));
    }

    onMoveAssetType(index,delta) {
        if (!delta) {
            return;
        }
        var ci = JSON.parse(this.props.create_info);
        var a1 = ci.assetTypes[index];
        var a2 = ci.assetTypes[index+delta];
        if (a1 && a2) {
            ci.assetTypes[index] = a2;
            ci.assetTypes[index+delta] = a1;
            this.props.onChange(JSON.stringify(ci));
        }
    }

    onDeleteAssetType(index) {
        var ci = JSON.parse(this.props.create_info);
        ci.assetTypes.splice(index,1);
        this.props.onChange(JSON.stringify(ci));
    }
    
    onChangeTemplateSubtypeText=(index,key,evt)=>{
        var ci = JSON.parse(this.props.create_info);
        ci.subtypes[index][key] = evt.target.value;
        this.props.onChange(JSON.stringify(ci));
    }
    
    onInsertTemplateSubtype=(index)=>{
        var ci = JSON.parse(this.props.create_info);
        if (!ci.subtypes) {
            ci.subtypes = [];
        }
        ci.subtypes.splice(index,0,{
            title: 'Subtype ' + (index+1),
            parameter: `tst${index+1}`,
        });
        this.props.onChange(JSON.stringify(ci));
    }

    onMoveTemplateSubtype=(index,delta)=>{
        if (!delta) {
            return;
        }
        var ci = JSON.parse(this.props.create_info);
        var a1 = ci.subtypes[index];
        var a2 = ci.subtypes[index+delta];
        if (a1 && a2) {
            ci.subtypes[index] = a2;
            ci.subtypes[index+delta] = a1;
            this.props.onChange(JSON.stringify(ci));
        }
    }

    onDeleteTemplateSubtype=(index)=>{
        var ci = JSON.parse(this.props.create_info);
        ci.subtypes.splice(index,1);
        this.props.onChange(JSON.stringify(ci));
    }
        
    
    extractYouTubeVideoID(text) {
        var obj = url.parse(text);
        if (obj) {
            if (obj.hostname == 'www.youtube.com') {
                if (obj.query) {
                    // See if there is a 'v' parameter
                    var params = querystring.parse(obj.query);
                    if (params.v) {
                        return params.v;
                    }
                }
            }
            else if (obj.hostname == 'youtu.be') {
                // youtu.be/<video_id>
                return obj.pathname.slice(1); 
            }
        }
        return null;
    }
    
    setVideoID(evt) {
        var txt = evt.target.value;
        var videoSrc = txt;
        if (txt) {
            if (txt.indexOf('http') < 0) {
                // assume this is a youtube video id and add the usual parameters
                videoSrc = "https://www.youtube.com/embed/"+txt+"?modestbranding=1&amp;rel=0&amp;showinfo=0";
            }
            else if (txt.indexOf('https://www.youtube.com/embed') < 0) {
                // if this is a youtube video we need to use the embed format
                var v = this.extractYouTubeVideoID(txt);
                if (v) {
                    videoSrc = "https://www.youtube.com/embed/"+v+"?modestbranding=1&amp;rel=0&amp;showinfo=0";
                }
                // else it's not youtube, just leave it alone.
            }
        }
        var ci = JSON.parse(this.props.create_info);
        ci.videoLink = videoSrc;
        this.props.onChange(JSON.stringify(ci));
    }
    
    renderAuthoringStepsImageChooser(step,index) {
        const _IMAGES = [
            'Categories.png',
            'Characters.png',
            'Conversation.png',
            'Debriefing.png',
            'Introduction.png',
            'Items.png',
            'Scenes.png',
            'Scoring.png',
            'Slides.png',
        ];
        
        var img_index = _IMAGES.indexOf(step.image);
        var val = (img_index >= 0) ? step.image : '';

        return (
            <label>
                {'image: '}
                <select value={val} onChange={this.onChangeAuthoringStepsText.bind(this,index,'image')}>
                    <option hidden key={-1} value={''}>{'select...'}</option>
                    {map(_IMAGES,function(f,i) { return (
                    <option key={i} value={f}>{f.slice(0,f.length-4)}</option>
                    )})}
                </select>
                {(img_index >= 0) ? 
                <img className="info-icon" src={GlobalConfig.StaticUrl + '/img/authoring_steps/' + step.image}/>
                : null }
            </label>
        );
    }

    renderAssetTypesImageChooser(step,index) {
        const _IMAGES = [
            '3DAssets.png',
            'Audio.png',
            'Images.png',
            'Text.png'
        ];
        
        var img_index = _IMAGES.indexOf(step.image);
        var val = (img_index >= 0) ? step.image : '';
        
        return (
            <label>
                {'image: '}
                <select value={val} onChange={this.onChangeAssetTypesText.bind(this,index,'image')}>
                    <option hidden key={-1} value={''}>{'select...'}</option>
                    {map(_IMAGES,function(f,i) { return (
                    <option key={i} value={f}>{f.slice(0,f.length-4)}</option>
                    )})}
                </select>
                {(img_index >= 0) ? 
                <img className="info-icon" src={GlobalConfig.StaticUrl + '/img/asset_types/' + step.image}/>
                : null }
            </label>
        );
    }
    
    render() {
        var self = this;
        var ci = JSON.parse(this.props.create_info);
        var ytplayer_id = 'ytplayer-create_info-editor';
        
        const canHaveSubTypes = (this.props.template.product === 'KidCitizen'); // for redmine #6618
        let subtypes = ci.subtypes || [];
        
        return (
            <div className={!!this.props.className ? `template-create-info-editor ${this.props.className}` : "template-create-info-editor"} onClick={(e)=>{
                e.preventDefault();
            }}>
                <h5>{'Create Info'}</h5>
                <label>{'short description:'}
                    <input type="text" value={ci.shortDesc} onChange={this.setText.bind(this,'shortDesc')}/>
                </label>
                <label>{'long description:'}
                    <textarea rows={4} value={ci.longDesc} onChange={this.setText.bind(this,'longDesc')}/>
                </label>
                <div className="edit-section">
                    <h6>{'How to play:'}</h6>
                    <ul>
                        {map(ci.howToPlaySteps,function(step,i) { return (
                        <li key={i}>
                            <div className="control-icons">
                                <button title="add step" onClick={self.onInsertHowToPlayStep.bind(self,i)}>
                                    <AccessibleIcon className="fa fa-plus" label="add step"/> 
                                </button>
                                <button title="move up" onClick={self.onMoveHowToPlayStep.bind(self,i,-1)} disabled={i==0}>
                                    <AccessibleIcon className="fa fa-caret-up" label="move up"/>
                                </button>
                                <button title="move down" onClick={self.onMoveHowToPlayStep.bind(self,i,1)} disabled={i==ci.howToPlaySteps.length-1}>
                                    <AccessibleIcon className="fa fa-caret-down" label="move down"/>
                                </button>
                                <button title="delete step" onClick={self.onDeleteHowToPlayStep.bind(self,i)}>
                                    <AccessibleIcon className="fa fa-trash" label="delete step"/>
                                </button>
                            </div>
                            <label className="step">{'Step'}
                                <input type="number" value={step.step} onChange={self.onChangeHowToPlayStep.bind(self,i)}/>
                            </label>
                            <input type="text" value={step.text} onChange={self.onChangeHowToPlayText.bind(self,i)}/>
                        </li>
                        )})}
                        <li key={ci.howToPlaySteps.length}>
                            <div className="control-icons">
                                <button title="add step" onClick={self.onInsertHowToPlayStep.bind(self,ci.howToPlaySteps.length)}>
                                    <AccessibleIcon className="fa fa-plus" label="add step"/> 
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                <label>{'demo link:'}
                    <input type="text" value={ci.demoLink} onChange={this.setText.bind(this,'demoLink')}/>
                    { ci.demoLink ?
                    <div className="demo">
                        <a href={ci.demoLink} target="_blank" rel="noopener noreferrer"><img src={GlobalConfig.StaticUrl + '/img/Play.svg'} style={{width:'24px'}}/>Play {this.props.template.name} demo</a>
                    </div>
                    : null}
                </label>
                <label>{'video link:'}
                    <input type="text" value={ci.videoLink} onChange={this.setVideoID}/>
                    { ci.videoLink ?
                        <div className="video">
                            <div className="aspect-ratio">
                                <iframe 
                                    id={ytplayer_id}
                                    type="text/html"
                                    src={ci.videoLink}
                                    frameBorder="0"
                                    allowFullScreen="1"/>
                            </div>
                        </div>
                    : null }
                    
                </label>
                <div className="edit-section">
                    <h6>{'Objectives:'}</h6>
                    <ul>
                        {map(ci.objectives,function(step,i) { return (
                        <li key={i}>
                            <div className="control-icons">
                                <button title="add objective" onClick={self.onInsertObjectiveStep.bind(self,i)}>
                                    <AccessibleIcon className="fa fa-plus" label="add objective"/> 
                                </button>
                                <button title="move up" onClick={self.onMoveObjectiveStep.bind(self,i,-1)} disabled={i==0}>
                                    <AccessibleIcon className="fa fa-caret-up" label="move up"/>
                                </button>
                                <button title="move down" onClick={self.onMoveObjectiveStep.bind(self,i,1)} disabled={i==ci.objectives.length-1}>
                                    <AccessibleIcon className="fa fa-caret-down" label="move down"/>
                                </button>
                                <button title="delete objective" onClick={self.onDeleteObjectiveStep.bind(self,i)}>
                                    <AccessibleIcon className="fa fa-trash" label="delete objective"/>
                                </button>
                            </div>
                            <label>{'title'}
                                <input type="text" value={step.title} onChange={self.onChangeObjectiveText.bind(self,i,'title')}/>
                            </label>
                            <label>{'subtitle'}
                                <input type="text" value={step.subtitle} onChange={self.onChangeObjectiveText.bind(self,i,'subtitle')}/>
                            </label>
                        </li>
                        )})}
                        <li key={ci.objectives.length}>
                            <div className="control-icons">
                                <button title="add objective" onClick={self.onInsertObjectiveStep.bind(self,ci.objectives.length)}>
                                    <AccessibleIcon className="fa fa-plus" label="add objective"/> 
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className="edit-section">
                    <h6>{'Authoring Steps:'}</h6>
                    <ul>
                        {map(ci.authoringSteps,function(step,i) { return (
                        <li key={i}>
                            <div className="control-icons">
                                <button title="add authoring step" onClick={self.onInsertAuthoringStep.bind(self,i)}>
                                    <AccessibleIcon className="fa fa-plus" label="add authoring step"/> 
                                </button>
                                <button title="move up" onClick={self.onMoveAuthoringStep.bind(self,i,-1)} disabled={i==0}>
                                    <AccessibleIcon className="fa fa-caret-up" label="move up"/>
                                </button>
                                <button title="move down" onClick={self.onMoveAuthoringStep.bind(self,i,1)} disabled={i==ci.authoringSteps.length-1}>
                                    <AccessibleIcon className="fa fa-caret-down" label="move down"/>
                                </button>
                                <button title="delete authoring step" onClick={self.onDeleteAuthoringStep.bind(self,i)}>
                                    <AccessibleIcon className="fa fa-trash" label="delete authoring step"/>
                                </button>
                            </div>
                            {self.renderAuthoringStepsImageChooser(step,i)}
                            <label>{'title'}
                                <input type="text" value={step.title} onChange={self.onChangeAuthoringStepsText.bind(self,i,'title')}/>
                            </label>
                        </li>
                        )})}
                        <li key={ci.authoringSteps.length}>
                            <div className="control-icons">
                                <button title="add authoring step" onClick={self.onInsertAuthoringStep.bind(self,ci.authoringSteps.length)}>
                                    <AccessibleIcon className="fa fa-plus" label="add authoring step"/> 
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                
                <div className="edit-section">
                    <h6>{'Asset Types:'}</h6>
                    <ul>
                        {map(ci.assetTypes,function(step,i) { return (
                        <li key={i}>
                            <div className="control-icons">
                                <button title="add asset type" onClick={self.onInsertAssetType.bind(self,i)}>
                                    <AccessibleIcon className="fa fa-plus" label="add asset type"/> 
                                </button>
                                <button title="move up" onClick={self.onMoveAssetType.bind(self,i,-1)} disabled={i==0}>
                                    <AccessibleIcon className="fa fa-caret-up" label="move up"/>
                                </button>
                                <button title="move down" onClick={self.onMoveAssetType.bind(self,i,1)} disabled={i==ci.assetTypes.length-1}>
                                    <AccessibleIcon className="fa fa-caret-down" label="move down"/>
                                </button>
                                <button title="delete asset type" onClick={self.onDeleteAssetType.bind(self,i)}>
                                    <AccessibleIcon className="fa fa-trash" label="delete asset type"/>
                                </button>
                            </div>
                            {self.renderAssetTypesImageChooser(step,i)}
                            <label>{'title'}
                                <input type="text" value={step.title} onChange={self.onChangeAssetTypesText.bind(self,i,'title')}/>
                            </label>
                        </li>
                        )})}
                        <li key={ci.assetTypes.length}>
                            <div className="control-icons">
                                <button title="add asset type" onClick={self.onInsertAssetType.bind(self,ci.assetTypes.length)}>
                                    <AccessibleIcon className="fa fa-plus" label="add asset type"/> 
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                
                { canHaveSubTypes ?
                <div className="edit-section">
                    <h6>{'Template Sub Types:'}</h6>
                    <ul>
                        {map(subtypes,(subType,i)=>{ return (
                        <li key={i}>
                            <div className="control-icons">
                                <button title="add subtype" onClick={()=>{this.onInsertTemplateSubtype(i)}} >
                                    <AccessibleIcon className="fa fa-plus" label="add subtype"/> 
                                </button>
                                <button title="move up" onClick={(e)=>{
                                        e.stopPropagation();
                                        e.preventDefault();
                                        this.onMoveTemplateSubtype(i,-1)
                                    }} disabled={i==0}>
                                    <AccessibleIcon className="fa fa-caret-up" label="move up"/>
                                </button>
                                <button title="move down" onClick={(e)=>{
                                        e.stopPropagation();
                                        e.preventDefault();
                                        this.onMoveTemplateSubtype(i,1)
                                    }} disabled={i==subtypes.length-1}>
                                    <AccessibleIcon className="fa fa-caret-down" label="move down"/>
                                </button>
                                <button title="delete subtype" onClick={()=>{this.onDeleteTemplateSubtype(i)}}>
                                    <AccessibleIcon className="fa fa-trash" label="delete subtype"/>
                                </button>
                            </div>
                            <label>{'title'}
                                <input type="text" value={subType.title} onChange={(evt)=>{this.onChangeTemplateSubtypeText(i,'title',evt)}}/>
                            </label>
                            <label>{'create parameter'}
                                <input type="text" value={subType.parameter} onChange={(evt)=>{this.onChangeTemplateSubtypeText(i,'parameter',evt)}}/>
                            </label>
                        </li>
                        )})}
                        <li key={subtypes.length}>
                            <div className="control-icons">
                                <button title="add asset type" onClick={()=>{this.onInsertTemplateSubtype(subtypes.length)}}>
                                    <AccessibleIcon className="fa fa-plus" label="add asset type"/> 
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                : null }
                
            </div>
        );
    }
}

TemplateCreateInfoEditor.propTypes = propTypes;
TemplateCreateInfoEditor.defaultProps = defaultProps;

export default TemplateCreateInfoEditor;
